import React from "react";
// import logo from "../pages/modules/Component/maamaaslog.png"; // Logo hidden as requested

const PrivacyPolicy = () => {
  return (
    <div style={styles.pageWrapper}>

      {/* Responsive CSS */}
      <style>
        {`
          @media (max-width: 900px) {
            .header-box {
              flex-direction: column !important;
              text-align: center !important;
            }
            .header-logo {
              margin-top: 12px !important;
            }
            .card {
              padding: 18px !important;
            }
          }

          /* Improve list spacing for nested lists */
          .pp-list { margin-top: 6px; }
          .pp-list li { margin: 6px 0; }
          .pp-sublist { margin-top: 6px; }
        `}
      </style>

      {/* Header Section */}
      <div style={styles.headerSection}>
        <div className="header-box" style={styles.header}>
          <h1 style={styles.heading}>Maamaa’s Privacy Policy</h1>
          {/* Logo hidden as requested */}
          {/*
            <img
              src={logo}
              className="header-logo"
              alt="Maamaa's logo"
              style={styles.logo}
            />
          */}
        </div>
      </div>

      {/* Content Card */}
      <div className="card" style={styles.card}>

        <h2 style={styles.title}>📜 Privacy Policy – Maamaa’s</h2>

        <p style={styles.meta}><strong>Company:</strong> Envision Integrated Services Pvt Ltd</p>
        <p style={styles.meta}><strong>App Name:</strong> Maamaa’s</p>
        <p style={styles.meta}><strong>Contact Email:</strong> <a href="mailto:envisionis.it@gmail.com">envisionis.it@gmail.com</a></p>

        <hr style={styles.line} />

        <Section title="1. Introduction">
          <ul style={styles.list} className="pp-list">
            <li>Maamaa’s (“we”, “our”, “us”) provides a platform connecting users with vendors offering:
              <ul style={styles.subList} className="pp-sublist">
                <li>Takeaway</li>
                <li>Dine-in</li>
                <li>Delivery</li>
                <li>Catering</li>
                <li>Event-based services</li>
              </ul>
            </li>

            <li>This Privacy Policy explains how we collect, use, share, and protect your information when you use the Maamaa’s mobile app.</li>

            <li>By using the app, you agree to the practices described in this Privacy Policy.</li>
          </ul>
        </Section>

        <Section title="2. Information We Collect">
          <ul style={styles.list} className="pp-list">
            <li>
              <strong>A. Information You Provide</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Name</li>
                <li>Mobile number</li>
                <li>Email address</li>
                <li>Delivery address</li>
                <li>Event details (for catering enquiries)</li>
                <li>Feedback or messages sent via the app</li>
              </ul>
            </li>

            <li>
              <strong>B. Automatically Collected Information</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Device information (model, OS version, device ID)</li>
                <li>App usage data</li>
                <li>Location information (only if you allow it)</li>
                <li>Log data such as IP address, time, date, and pages viewed</li>
              </ul>
            </li>

            <li>
              <strong>C. Location Data</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Show nearby vendors and restaurants</li>
                <li>Improve delivery accuracy</li>
                <li>Provide better service recommendations</li>
                <li>You can disable location access anytime in your device settings</li>
              </ul>
            </li>
          </ul>
        </Section>

        <Section title="3. How We Use Your Information">
          <ul style={styles.list} className="pp-list">
            <li>Create and manage your account</li>
            <li>Process food orders and catering enquiries</li>
            <li>Connect you with vendors</li>
            <li>Provide customer support</li>
            <li>Improve app features and user experience</li>
            <li>Send notifications about orders, offers, and updates</li>
            <li>Enhance safety and prevent misuse of the app</li>
          </ul>
        </Section>

        <Section title="4. Account Deletion">
          <ul style={styles.list} className="pp-list">
            <li>All personal information, delivery addresses, order history, and account-related data are permanently deleted from our servers when you delete your account.</li>
            <li>Some anonymized data may remain for legal, regulatory, or business purposes.</li>
            <li>
              To delete your account:
              <ul style={styles.subList} className="pp-sublist">
                <li>Open the app → Settings → Account → Delete Account</li>
                <li>Confirm your request</li>
                <li>Your account and data will be removed automatically</li>
              </ul>
            </li>
          </ul>
        </Section>

        <Section title="5. Third-Party Services & APIs">
          <ul style={styles.list} className="pp-list">
            <li>
              <strong>A. Google APIs & Firebase</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Firebase Cloud Messaging (FCM): Sends order updates and notifications.</li>
                <li>Google Maps & Places APIs: Show nearby vendors and delivery addresses accurately.</li>
                <li>
                  <strong>Privacy References:</strong>
                  <ul style={styles.subList}>
                    <li>
                      <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                        Firebase Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                        Google APIs Privacy Policy
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <strong>B. Payment Gateway – Razorpay</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Payments are securely processed via Razorpay, which collects necessary billing, card, and transaction information to complete payments.</li>
                <li>We do not store sensitive payment data on our servers.</li>
                <li>
                  <a href="https://razorpay.com/privacy/" target="_blank" rel="noopener noreferrer">
                    Razorpay Privacy Policy
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </Section>

        <Section title="6. How We Share Your Information">
          <ul style={styles.list} className="pp-list">
            <li>
              <strong>A. With Vendors</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Name</li>
                <li>Phone number</li>
                <li>Delivery address</li>
                <li>Event details</li>
              </ul>
            </li>

            <li>
              <strong>B. With Service Providers</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Razorpay (payments)</li>
                <li>Firebase (messaging & analytics)</li>
                <li>Google APIs (Maps & location services)</li>
              </ul>
            </li>

            <li>
              <strong>C. Legal Requirements</strong>
              <ul style={styles.subList} className="pp-sublist">
                <li>Law enforcement</li>
                <li>Court orders</li>
                <li>Regulatory authorities</li>
              </ul>
            </li>
          </ul>
        </Section>

        <Section title="7. Data Storage & Security">
          <ul style={styles.list} className="pp-list">
            <li>We implement reasonable measures to protect your information.</li>
            <li>No method of data transmission is 100% secure.</li>
            <li>Payments are handled securely by Razorpay.</li>
          </ul>
        </Section>

        <Section title="8. Data Retention">
          <ul style={styles.list} className="pp-list">
            <li>We retain your data as long as your account is active and necessary for providing services or legal purposes.</li>
            <li>Deleted account data is permanently removed from our servers, except anonymized data kept for legal purposes.</li>
          </ul>
        </Section>

        <Section title="9. Your Rights">
          <ul style={styles.list} className="pp-list">
            <li>Access your data</li>
            <li>Update or correct your information</li>
            <li>Delete your account (via app)</li>
            <li>Withdraw permissions ( notifications, etc.)</li>
          </ul>
        </Section>

        <Section title="10. Children’s Privacy">
          <ul style={styles.list} className="pp-list">
            <li>Maamaa’s does not target or knowingly collect data from children under 13.</li>
            <li>If you believe a child has provided information, contact us at <a href="mailto:envisionis.it@gmail.com">envisionis.it@gmail.com</a>.</li>
          </ul>
        </Section>

        <Section title="11. Third-Party Links">
          <ul style={styles.list} className="pp-list">
            <li>The app may contain links to third-party websites. We are not responsible for their privacy practices.</li>
          </ul>
        </Section>

        <Section title="12. Changes to This Privacy Policy">
          <ul style={styles.list} className="pp-list">
            <li>We may update this policy occasionally.</li>
            <li>Changes will be posted in-app with a new “Last Updated” date.</li>
          </ul>
        </Section>

        <Section title="13. Contact Us">
          <ul style={styles.list} className="pp-list">
            <li>Email: <a href="mailto:envisionis.it@gmail.com">envisionis.it@gmail.com</a></li>
            <li>Company: Envision Integrated Services Pvt Ltd</li>
          </ul>
        </Section>

        {/* Permissions Table */}
        <h3 style={styles.title}>📱 Permissions & Justifications</h3>

        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Permission</th>
              <th style={styles.th}>Purpose / Justification</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td style={styles.td}>ACCESS_FINE_LOCATION / ACCESS_COARSE_LOCATION</td>
              <td style={styles.td}>Track location for order delivery and show nearby vendors.</td>
            </tr>

            <tr>
              <td style={styles.td}>INTERNET</td>
              <td style={styles.td}>Access data from our servers for orders, updates, and vendor info.</td>
            </tr>

            <tr>
              <td style={styles.td}>CALL_PHONE</td>
              <td style={styles.td}>Contact support directly from the app.</td>
            </tr>

            <tr>
              <td style={styles.td}>POST_NOTIFICATIONS</td>
              <td style={styles.td}>Send order updates, promotional messages, and alerts.</td>
            </tr>

            <tr>
              <td style={styles.td}>FOREGROUND_SERVICE</td>
              <td style={styles.td}>Keep location tracking active in the background.</td>
            </tr>

            <tr>
              <td style={styles.td}>REQUEST_IGNORE_BATTERY_OPTIMIZATIONS</td>
              <td style={styles.td}>Ensure background services for order tracking work reliably.</td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  );
};

// Reusable Section UI
const Section = ({ title, children }) => (
  <div style={{ marginBottom: "18px" }}>
    <h3 style={{ fontSize: "20px", fontWeight: 600, color: "#333", marginBottom: 8 }}>{title}</h3>
    <div style={{ marginTop: 4, color: "#444" }}>{children}</div>
  </div>
);

// Styles
const styles = {
  pageWrapper: {
    background: "#f7fafc",
    minHeight: "100vh",
    marginTop: "30px",
    padding: "20px",
    fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    color: "#1f2937",
  },
  headerSection: {
    background: "#ffffff",
    padding: "18px 20px",
    borderRadius: 12,
    boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
    marginBottom: 20,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
  },
  heading: {
    fontSize: 26,
    fontWeight: 700,
    color: "#111827",
    margin: 0,
  },
  logo: {
    width: 72,
    height: 72,
    objectFit: "contain",
  },
  card: {
    background: "#ffffff",
    padding: 24,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(2,6,23,0.06)",
    lineHeight: 1.7,
    maxWidth: 1420,
    margin: "0 auto",
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 10,
    color: "#0f62fe",
  },
  meta: {
    margin: "4px 0",
    color: "#374151",
  },
  line: {
    margin: "18px 0",
    border: 0,
    height: 1,
    background: "#e6e9ef",
  },
  list: {
    paddingLeft: 20,
    marginTop: 6,
    lineHeight: 1.6,
    listStyleType: "disc",
  },
  subList: {
    paddingLeft: 20,
    marginTop: 6,
    lineHeight: 1.55,
    listStyleType: "circle",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 12,
    border: "1px solid #e6e9ef",
  },
  th: {
    background: "#eef2ff",
    padding: 12,
    borderBottom: "1px solid #e6e9ef",
    fontWeight: 600,
    textAlign: "left",
  },
  td: {
    padding: 12,
    borderBottom: "1px solid #f1f5f9",
    verticalAlign: "top",
  },
};

export default PrivacyPolicy;




// import React from "react";

// const PrivacyPolicy = () => {
//   return (
//     <div style={styles.pageWrapper}>
//       <style>
//         {`
//           @media (max-width: 900px) {
//             .header-box {
//               flex-direction: column !important;
//               text-align: center !important;
//             }
//             .card {
//               padding: 18px !important;
//             }
//           }

//           .pp-list { margin-top: 6px; }
//           .pp-list li { margin: 6px 0; }
//           .pp-sublist { margin-top: 6px; }
//         `}
//       </style>

//       {/* Header */}
//       <div style={styles.headerSection}>
//         <div className="header-box" style={styles.header}>
//           <h1 style={styles.heading}>Maamaas Movers Privacy Policy</h1>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="card" style={styles.card}>
//         <h2 style={styles.title}>📜 Maamaas Movers Policy</h2>

//         <p style={styles.meta}><strong>Last Updated:</strong> 18 Feb 2025</p>
//         <p style={styles.meta}><strong>Company:</strong> Envision Integrated Services Pvt Ltd</p>
//         <p style={styles.meta}><strong>App Name:</strong> Maamaas Movers</p>
//         <p style={styles.meta}><strong>Contact Email:</strong> <a href="mailto:envisionis.it@gmail.com">envisionis.it@gmail.com</a></p>

//         <hr style={styles.line} />

//         <Section title="1. Introduction">
//           <ul style={styles.list} className="pp-list">
//             <li>
//               Welcome to Maamaas Movers, operated by Envision Integrated Services Pvt Ltd.
//               This Privacy Policy explains how we collect, use, disclose, and
//               protect information when you use our Delivery Partner application.
//             </li>
//             <li>By using this App, you agree to this Privacy Policy.</li>
//           </ul>
//         </Section>

//         <Section title="2. Information We Collect">
//           <ul style={styles.list} className="pp-list">
//             <li>
//               <strong>A. Personal Information</strong>
//               <ul style={styles.subList} className="pp-sublist">
//                 <li>Full Name</li>
//                 <li>Phone Number</li>
//                 <li>Email Address</li>
//                 <li>Profile Photo</li>
//                 <li>Address</li>
//                 <li>Government IDs (if required for verification)</li>
//                 <li>Bank account / UPI details (for payouts)</li>
//                 <li>Feedback or messages sent via the app</li>
//               </ul>
//             </li>

//             <li>
//               <strong>B. Location Information</strong>
//               <ul style={styles.subList} className="pp-sublist">
//                 <li>Real-time location (foreground & background)</li>
//                 <li>Device GPS data</li>
//                 <li>Assign nearby orders</li>
//                 <li>Track deliveries</li>
//                 <li>Show route navigation</li>
//                 <li>Ensure safety and order accuracy</li>
//                 <li>
//                   Location tracking may continue in background only during active delivery.
//                 </li>
//               </ul>
//             </li>

//             <li>
//               <strong>C. Device Information</strong>
//               <ul style={styles.subList} className="pp-sublist">
//                 <li>Device model</li>
//                 {/* <li>OS version</li>
//                 <li>App version</li> */}
//                 <li>Crash logs</li>
//               </ul>
//             </li>
//           </ul>
//         </Section>

//         <Section title="3. How We Use Your Information">
//           <ul style={styles.list} className="pp-list">
//             <li>Create and manage your delivery partner account</li>
//             <li>Assign and track deliveries</li>
//             <li>Process earnings and payments</li>
//             <li>Provide customer support</li>
//             <li>Prevent fraud and misuse</li>
//             <li>Comply with legal obligations</li>
//           </ul>
//         </Section>

//         <Section title="4. Data Sharing">
//           <ul style={styles.list} className="pp-list">
//             <li>Customers (limited info during delivery)</li>
//             <li>Restaurants / vendors</li>
//             <li>Payment gateway (Razorpay)</li>
//             <li>Government authorities if legally required</li>
//             <li>We do NOT sell your personal data.</li>
//           </ul>
//         </Section>

//         <Section title="5. Data Storage & Security">
//           <ul style={styles.list} className="pp-list">
//             <li>We implement reasonable security measures.</li>
//             <li>No method of transmission is 100% secure.</li>
//             <li>Payments are handled securely by Razorpay.</li>
//           </ul>
//         </Section>

//         <Section title="6. Data Retention">
//           <ul style={styles.list} className="pp-list">
//             <li>Data retained while account is active.</li>
//             <li>Retained as required by legal obligations.</li>
//             <li>Used for dispute resolution and fraud prevention.</li>
//             <li>You may request account deletion by contacting us.</li>
//           </ul>
//         </Section>

//         <Section title="7. Your Rights">
//           <ul style={styles.list} className="pp-list">
//             <li>Access your data</li>
//             <li>Update incorrect information</li>
//             <li>Request deletion</li>
//             <li>Withdraw consent (may affect app usage)</li>
//             <li>Contact: it.envisionis@gmail.com</li>
//           </ul>
//         </Section>

//         <Section title="8. Third-Party Services">
//   <ul style={styles.list} className="pp-list">
//     <li>
//       <strong>A. Google APIs & Firebase</strong>
//       <ul style={styles.subList} className="pp-sublist">
//         <li>
//           Firebase Cloud Messaging (FCM): Sends order updates and notifications.
//         </li>
//         <li>
//           Google Maps & Places APIs: Show nearby vendors and delivery addresses accurately.
//         </li>
//         <li>
//           <strong>Privacy References:</strong>
//           <ul style={styles.subList}>
//             <li>
//               <a
//                 href="https://firebase.google.com/support/privacy"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Firebase Privacy Policy
//               </a>
//             </li>
//             <li>
//               <a
//                 href="https://policies.google.com/privacy"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Google APIs Privacy Policy
//               </a>
//             </li>
//           </ul>
//         </li>
//       </ul>
//     </li>

//     <li>
//       <strong>B. Payment Gateway – Razorpay</strong>
//       <ul style={styles.subList} className="pp-sublist">
//         <li>
//           Payments are securely processed via Razorpay, which collects necessary
//           billing, card, and transaction information to complete payments.
//         </li>
//         <li>
//           We do not store sensitive payment data on our servers.
//         </li>
//         <li>
//           <a
//             href="https://razorpay.com/privacy/"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Razorpay Privacy Policy
//           </a>
//         </li>
//       </ul>
//     </li>
//   </ul>
// </Section>


//         <Section title="9. Children’s Privacy">
//           <ul style={styles.list} className="pp-list">
//             <li>This app is not intended for individuals under 18 years of age.</li>
//           </ul>
//         </Section>

//         <Section title="10. Changes to This Policy">
//           <ul style={styles.list} className="pp-list">
//             <li>We may update this Privacy Policy from time to time.</li>
//             <li>Updates will be posted inside the app.</li>
//           </ul>
//         </Section>

//         <Section title="11. Contact Us">
//           <ul style={styles.list} className="pp-list">
//             <li>Company: Envision Integrated Services Pvt Ltd</li>
//             <li>Email: envisionis.it@gmail.com</li>
//           </ul>
//         </Section>

//         {/* Permissions Table */}
//         <h3 style={styles.title}>📱 Permissions & Justifications</h3>

//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>Permission</th>
//               <th style={styles.th}>Purpose / Justification</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td style={styles.td}>ACCESS_FINE_LOCATION / ACCESS_COARSE_LOCATION</td>
//               <td style={styles.td}>Track location for order delivery and navigation.</td>
//             </tr>
//             <tr>
//               <td style={styles.td}>INTERNET</td>
//               <td style={styles.td}>Access server data for orders and updates.</td>
//             </tr>
//             <tr>
//               <td style={styles.td}>CALL_PHONE</td>
//               <td style={styles.td}>Contact support from the app.</td>
//             </tr>
//             <tr>
//               <td style={styles.td}>POST_NOTIFICATIONS</td>
//               <td style={styles.td}>Send order updates and alerts.</td>
//             </tr>
//             <tr>
//               <td style={styles.td}>FOREGROUND_SERVICE</td>
//               <td style={styles.td}>Enable active delivery tracking.</td>
//             </tr>
//             <tr>
//               <td style={styles.td}>REQUEST_IGNORE_BATTERY_OPTIMIZATIONS</td>
//               <td style={styles.td}>Ensure background tracking works properly.</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// const Section = ({ title, children }) => (
//   <div style={{ marginBottom: "18px" }}>
//     <h3 style={{ fontSize: "20px", fontWeight: 600, color: "#333", marginBottom: 8 }}>
//       {title}
//     </h3>
//     <div style={{ marginTop: 4, color: "#444" }}>{children}</div>
//   </div>
// );

// const styles = {
//   pageWrapper: { background: "#f7fafc", minHeight: "100vh", padding: 20,marginTop:"60px" },
//   headerSection: { background: "#fff", padding: 18, borderRadius: 12, marginBottom: 20 },
//   header: { display: "flex", justifyContent: "space-between", alignItems: "center" },
//   heading: { fontSize: 26, fontWeight: 700, margin: 0 },
//   card: { background: "#fff", padding: 24, borderRadius: 12, maxWidth: 1200, margin: "0 auto" },
//   title: { fontSize: 20, fontWeight: 700, marginBottom: 10, color: "#0f62fe" },
//   meta: { margin: "4px 0" },
//   line: { margin: "18px 0", height: 1, background: "#e6e9ef", border: 0 },
//   list: { paddingLeft: 20, listStyleType: "disc" },
//   subList: { paddingLeft: 20, listStyleType: "circle" },
//   table: { width: "100%", borderCollapse: "collapse", marginTop: 12 },
//   th: { background: "#eef2ff", padding: 12, textAlign: "left" },
//   td: { padding: 12, borderBottom: "1px solid #eee" },
// };

// export default PrivacyPolicy;

